import { useEffect } from "react";
import { useSettingsStore } from "@/stores/SettingsStore";

/**
 * Hook that applies the user's font size preference to the HTML root element.
 * This scales all rem-based font sizes proportionally without breaking existing styles.
 *
 * - small: 14px (87.5% of default)
 * - medium: 16px (100% - default, preserves existing design)
 * - large: 18px (112.5% of default)
 * - extra-large: 20px (125% of default)
 * - extra-extra-large: 22px (137.5% of default)
 */
export function useFontSize() {
  const fontSize = useSettingsStore((state) => state.fontSize);

  useEffect(() => {
    const htmlElement = document.documentElement;

    // Apply the data attribute for the current font size
    htmlElement.setAttribute("data-font-size", fontSize);

    // Apply the corresponding root font-size
    const fontSizeMap = {
      small: "14px",
      medium: "16px",
      large: "18px",
      "extra-large": "20px",
      "extra-extra-large": "22px",
    };

    htmlElement.style.fontSize = fontSizeMap[fontSize];
  }, [fontSize]);
}